<template>
  <div class="bg-gray-100 flex flex-col justify-center py-24 sm:px-6 lg:px-8">
    <div class="sm:mx-auto sm:w-full sm:max-w-md">
      <img
        class="mx-auto h-12 w-auto"
        src="../assets/nav_logo.svg"
        alt="MTcontrol"
      />
    </div>

    <div class="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
      <div class="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
        <form class="login" @submit.prevent="login">
          <div>
            <label
              for="email"
              class="block text-sm font-medium leading-5 text-gray-700"
            >
              {{ $t('message.login.usuario') }}
            </label>
            <div class="mt-1 rounded-md shadow-sm">
              <input
                id="login"
                type="text"
                required
                v-model="user"
                class="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md placeholder-gray-400 focus:outline-none focus:ring-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"
              />
            </div>
          </div>

          <div class="mt-6">
            <label
              for="password"
              class="block text-sm font-medium leading-5 text-gray-700"
            >
              {{ $t('message.login.password') }}
            </label>
            <div class="mt-1 rounded-md shadow-sm">
              <input
                id="password"
                type="password"
                v-model="password"
                required
                class="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md placeholder-gray-400 focus:outline-none focus:ring-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"
              />
            </div>
          </div>

          <div class="mt-6">
            <span class="block w-full rounded-md shadow-sm">
              <button
                type="submit"
                class="w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-gray-600 hover:bg-gray-500 focus:outline-none focus:border-gray-700 focus:ring-gray active:bg-gray-700 transition duration-150 ease-in-out"
              >
                {{ $t('message.login.entrar') }}
              </button>
            </span>
          </div>
        </form>
      </div>
    </div>
    <login-modal v-show="error" />
  </div>
</template>

<script>
import LoginModal from '@/components/UI/LoginModal';
import { getLocale } from '@/utils/i18n';
export default {
  name: 'login',
  components: { LoginModal },
  data() {
    return {
      user: '',
      password: '',
      error: false
    };
  },
  methods: {
    async login() {
      const user = this.user;
      const password = this.password;
      const locale = getLocale();
      await this.$store.dispatch('login', { user, password, locale });
      if (this.auth.result === 'error') {
        this.error = true;
        setTimeout(() => {
          this.error = false;
        }, 3000);
      }
    }
  },
  computed: {
    auth() {
      return this.$store.getters.auth;
    }
  }
};
</script>
